module.exports = require("imagemin-pngquant");;